/* RESPONSIBLE TEAM: team-ai-agent */
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class AppsAppOperatorResolutionBotBehaviorsRoute extends IntercomRoute {}
